export const PAGE_SIZE = 12;

export const pageParams = (page, size) => ({
  limit: size || PAGE_SIZE,
  offset: (size || PAGE_SIZE) * (page - 1),
});
